import checkIsConnectedToStripe from '@dashboard/services/seller/checkIsConnectedToStripe';
import { hasRecurringPrice } from '@dashboard/services/getBillingModel';

export default function getShouldSyncSubscription(page = {}, seller = {}) {
  // if the seller is not connected to stripe, we should not sync
  if (!checkIsConnectedToStripe(seller)) {
    return false;
  }

  // Multi-price products sync every price (one-time + recurring) through the
  // API's syncStripePrices on save, so the legacy single-price "create
  // subscription in Stripe" flow doesn't apply to them.
  if (page.product?.prices?.length > 0) {
    return false;
  }

  // Legacy single-price products: only a recurring price needs the legacy sync
  // (with no prices[], hasRecurringPrice falls back to product.type).
  if (!hasRecurringPrice(page.product)) {
    return false;
  }

  // TODO(M14): legacy product-scalar fallback — remove once the prices[] backfill migration has run (product.planActive)
  if (!page.product.planActive) {
    return true;
  }

  // if any variant option does not have a stripePriceId or stripeProductId then we should sync
  const shouldSyncVariants = page.product.variants.some(variant => {
    return variant.options.some(option => {
      if (!option.additionalChargeAmount) {
        return false;
      }

      if (option.type !== 'recurring') {
        return false;
      }

      return !option.stripePriceId || !option.stripeProductId;
    });
  });

  if (shouldSyncVariants) {
    return true;
  }

  return false;
}
